import React from 'react'
import { SubjectLeaf } from 'frontend/types'
import styles from './SubjectBlock.module.css'
import { BlockTracking } from 'frontend/types'
import { blockItemClick } from 'frontend/utils/analytics/dataLayerDispatchers'
import SpaLink from 'components/SpaLink/SpaLink'
import classnames from 'classnames'

interface SubjectPillsProps {
  itemList: SubjectLeaf[]
  title?: string
  className?: string
  blockTracking: BlockTracking
  isChildSubject?: boolean
  parentSlug?: string
  dataTestId?: string
}

interface PillItemProps {
  children: React.ReactNode
  href: string
  label: string
  blockTracking: BlockTracking
  itemIndex: number
  isChildSubject?: boolean
}

export const PillItem = ({
  children,
  href,
  label,
  blockTracking,
  itemIndex,
  isChildSubject = false,
}: PillItemProps) => (
  <SpaLink
    onClick={() => {
      blockItemClick({
        blockTracking,
        itemIndex,
        item: { link: href, title: label },
      })
    }}
    href={href}
    className={classnames(styles.link, {
      [`${styles.childSubjectLink}`]: isChildSubject,
    })}
    data-trk-subject-card={label}
  >
    {children}
  </SpaLink>
)

const SubjectBlock = ({
  itemList,
  title,
  className,
  blockTracking,
  isChildSubject,
  dataTestId,
}: SubjectPillsProps) => {
  return (
    <div className={className}>
      {title && (
        <header className={styles.header}>
          <h2>{title}</h2>
        </header>
      )}
      <div className={styles.wrapper} data-testid={dataTestId}>
        {itemList.map((item: SubjectLeaf, index) => {
          const itemSlug = `/amne/${item.route}`

          return (
            <PillItem
              isChildSubject={isChildSubject}
              href={itemSlug}
              label={item.name}
              key={itemSlug}
              blockTracking={blockTracking}
              itemIndex={index + 1}
            >
              {item.name}
            </PillItem>
          )
        })}
      </div>
    </div>
  )
}

export default SubjectBlock
